import {CommonModule} from '@angular/common';
import { Component, HostBinding, Input, Output, EventEmitter } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import { stripEmojis } from 'src/packages/mitsBasics';
import {MitsFormInputControlValueAccessorDirective} from './directives/mits-form-input.control-value-accessor.directive';

/**
 * Formularfeld für einen einfachen Input
 */
@Component({
  selector: 'mits-form-input',
  templateUrl: './mits-form-input.component.html',
  styleUrls: ['./mits-form-input.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
  ],
  hostDirectives: [MitsFormInputControlValueAccessorDirective],
})
export class MitsFormInputComponent {
  // Wert des Eingabefeldes
  @Input() value?: string;
  // Label des Auswahlfeldes
  @Input() label?: string;
  // Position des Labels
  @Input() labelPlacement: 'floating' | 'stacked' = 'stacked';
  // Boolean, der angibt, ob das Feld deaktiviert ist
  @Input() disabled = false;
  // Boolean, der angibt, ob das Feld nur lesbar ist
  @Input() readonly = false;
  // Typ des Eingabefeldes
  @Input() type: 'text' | 'number' | 'password' | 'email' | 'tel' = 'text';
  // Soll das Feld als Textarea dargestellt werden?
  @Input() textarea = false;
  // Anzahl der Zeichen, die maximal eingegeben werden können
  @Input() maxCharacters: number | undefined = undefined;
  // Verhindert die Eingabe von Emojis (werden bei Eingabe/Einfügen sofort entfernt)
  @Input() blockEmoji = false;
  // Fügt der Komponente automatisch die Klasse 'mits-form-item' hinzu
  @HostBinding('class') class = 'mits-form-item';
  // Event-Emitter für die Benachrichtigung, wenn der Wert geändert wird
  @Output() valueChange = new EventEmitter<string | undefined>();

  /**
   * Wird aufgerufen, wenn sich der Wert des Eingabefeldes ändert
   */
  onInputChange(event: any): void {
    let value = event.target.value;
    // Emojis direkt bei der Eingabe entfernen, sodass sie gar nicht erscheinen.
    // WICHTIG: Nicht eingreifen, solange eine IME-Komposition läuft (z.B. Emoji-
    // Eingabe über den System-Picker per Namen unter Linux/ibus, macOS, Windows).
    // Ein Eingriff via event.target.value würde die Komposition abbrechen und den
    // getippten Namen als Text stehen lassen. Nach Abschluss der Komposition feuert
    // ein weiteres Event mit isComposing=false, bei dem das Emoji entfernt wird.
    if (this.blockEmoji && !event.isComposing) {
      const stripped = stripEmojis(value);
      if (stripped !== value) {
        value = stripped;
        // Anzeige sofort bereinigen
        event.target.value = stripped;
      }
    }
    this.valueChange.emit(value);
  }
}
